import React from 'react'
import './User_SetNameState.css'
import '../UserPanel.css'
import general_zoom from '../../../images/tooltip/general_zoom.svg'
class User_TutorialState extends React.Component{

    render() {
        let mainStyle = {
            "paddingTop":"100px",
            "paddingLeft":"100px",
            "width":"1400px",
            "height":"281px",
            "display":"flex",
            "flexDirection":"column",
            "justifyContent":"space-between",
            "alignItems":"flex-start"};
        return <div style={mainStyle}>
            <div className='user-header-text'>Обучение игре</div>
            <div className='user-set-name-tooltip-container'>
                <img src={general_zoom} alt={"icon"} className='user-set-name-tooltip-image'/>
                <div className='user-set-name-tooltip-text'>Перейдите в общий зал</div>
            </div>
        </div>
    }
}

export default User_TutorialState;
